import { TFunction } from 'i18next'
import { ENotEditableReason } from './programmed-message.type'

export const getNotEditableReasonLabel = (t: TFunction, reason: ENotEditableReason | null): string => {
  const labelByReason: Record<ENotEditableReason, string> = {
    [ENotEditableReason.GLOBAL_WORKFLOW]: t(
      'pages.configuration.messages.not-editable-reason.global-workflow',
    ),
    [ENotEditableReason.HAS_EVENT_TRIGGER]: t(
      'pages.configuration.messages.not-editable-reason.has-event-trigger',
    ),
    [ENotEditableReason.NO_FOLLOWUP]: t('pages.configuration.messages.not-editable-reason.no-followup'),
    [ENotEditableReason.TRIGGERS_ACROSS_FOLLOWUPS]: t(
      'pages.configuration.messages.not-editable-reason.triggers-across-followups',
    ),
    [ENotEditableReason.UNSUPPORTED_GRAPH]: t(
      'pages.configuration.messages.not-editable-reason.unsupported-graph',
    ),
  }

  return reason ? labelByReason[reason] : t('pages.configuration.messages.not-editable-reason.unknown')
}

export const isContentPartial = (reason: ENotEditableReason | null): boolean =>
  reason === ENotEditableReason.UNSUPPORTED_GRAPH
